/**
 * Connection state
 */
export enum ConnectionState {
  /**
   * connected
   */
  CONNECTED = 'CONNECTED',
  /**
   * disconnect
   */
  DISCONNECTED = 'DISCONNECTED',
}

/**
 * Wrote reporter
 */
export class WroteReporter {

  constructor(
    /**
     * Wrote is ok
     */
    public ok: boolean,
    /**
     * Wrote data
     */
    public binary: Uint8Array,
    /**
     * control exit
     */
    public controlExit: boolean,
    /**
     * exception
     */
    public exception?: Error,
  ) {

  }

}

/**
 * Read options
 */
export class ReadOptions {
  public readonly timeout?: number;
  public constructor(options?: {
    /**
     * Read timeout, default is 10
     */
    timeout?: number,
  }) {
    this.timeout = options?.timeout;
  }
}

